import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-merge-cart-item-dialog',
  templateUrl: './merge-cart-item-dialog.html',
  styleUrls: ['./merge-cart-item-dialog.scss'],
})
export class MergeCartItemDialogComponent implements OnInit {
  duplicateEntries

  cartItem

  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.data$.subscribe((data) => {
      this.duplicateEntries = data.duplicateEntries
      this.cartItem = data.cartItem
    })
  }

  ngOnInit(): void {}

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MERGE_CART_ITEM,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
